import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getTranslate} from 'react-localize-redux';
import Validator from 'validatorjs';
import api from '../../helpers/api';
import {loadLanguage} from '../redux/localeReducer';
import {notifySuccess, notifyError} from '../redux/notificationReducer';
import {SectionLoader} from '../../common/components/loader';
import {Error, Input} from '../../common/components/form';
import Modal from "react-bootstrap-modal";
import PropTypes from "prop-types";

const apiHost = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

class ChatModal extends Component {
	constructor(props) {
		super(props);

		const {loadLanguage} = props;
		const chatForm = {
			"en": {
				"chat_modal_title": "Chat",
				"chat_form_message_required": "Message is required."
			},
			"es": {
				"chat_modal_title": "Chat",
				"chat_form_message_required": "Message is required."
			}
		};
		loadLanguage(chatForm);

		this.messagesEnd = null;
		this.state = {
			isLoading: false,
			isFormSubmitting: false,
			errors: {},
			chats: [
				{ role: "assistant", "content": "Hello, How can I help you today?", "attachment": ""}
				//{ role: "user", "content": "Hello"},
			],
			isTyping: false,
			chatForm: {
				message: '',
				attachment: '',
				attachment_mimetype: ''
			}
		}
	}

	_closeModal = () => {
		const {closeAction} = this.props;

		this.setState({errors: {}, chatForm: {
			message: ''
		}});
		closeAction();
	};

	updateState = (object) => {
		this.setState({
			chatForm: {
				...this.state.chatForm,
				...object
			}
		})
	};

	formSubmit = (e) => {
		e.preventDefault();
		const {chatForm} = this.state;

		const validators = {
			'message': 'required'
		};

		const messages = {
			"required.message": "chat_form_message_required",
		};
		let validation = new Validator(chatForm, validators, messages);
		if(validation.fails()) {
			return this.setState({errors: validation.errors.all()});
		}

		return this.handleSubmit(chatForm);
	};

	handleSubmit = async (values) => {
		const {notifyError} = this.props;
		const {chats} = this.state;
		try {
			const url = `${apiHost}/uploads/openai/${values.attachment}`
			chats.push({role: 'user', content: values.message, attachment: url});
			this.setState({isFormSubmitting: true, chats: chats, chatForm: {
					message: '',
					attachment: '',
					attachment_mimetype: ''
				}});
			this.scrollToBottom();

			const formData = Object.assign({}, values);
			const response = await api.post('/openai', formData);
			console.log(response);
			chats.push(response.data.data);

			this.setState({errors: {}, isFormSubmitting: false, chats: chats, chatForm: {
				message: '',
				attachment: '',
				attachment_mimetype: ''
			}});

			this.scrollToBottom();
		} catch (error) {
			notifyError(error.message);
			this.setState({isFormSubmitting: false});
		}
	};

	formSubmitImageGenerate = (e) => {
		e.preventDefault();
		const {chatForm} = this.state;

		const validators = {
			'message': 'required'
		};

		const messages = {
			"required.message": "chat_form_message_required",
		};
		let validation = new Validator(chatForm, validators, messages);
		if(validation.fails()) {
			return this.setState({errors: validation.errors.all()});
		}

		return this.handleSubmitImageGenerate(chatForm);
	};

	handleSubmitImageGenerate = async (values) => {
		const {notifyError} = this.props;
		const {chats} = this.state;
		try {
			chats.push({role: 'user', content: values.message, attachment: ''});
			this.setState({isFormSubmitting: true, chats: chats, chatForm: {
					message: '',
					attachment: '',
					attachment_mimetype: ''
				}});
			this.scrollToBottom();

			const formData = Object.assign({}, values);
			const response = await api.post('/openai/generate-image', formData);
			chats.push(response.data.data);

			this.setState({errors: {}, isFormSubmitting: false, chats: chats, chatForm: {
				message: '',
				attachment: '',
				attachment_mimetype: ''
			}});

			this.scrollToBottom();
		} catch (error) {
			notifyError(error.message);
			this.setState({isFormSubmitting: false});
		}
	};

	imageUpload = async (e) => {
		const {notifyError} = this.props;
		const file = e.target.files[0];
		if(file) {
			try {
				const formData = new FormData();
				formData.append('file', file);
				const response = await api.post('/openai/upload', formData);
				this.setState({
					chatForm: {
						...this.state.chatForm,
						...{attachment: response.data.file.filename, attachment_mimetype: response.data.file.mimetype}
					}
				});

			} catch (error) {
				notifyError(error.message);
			}
		} else {
			this.setState({
				chatForm: {
					...this.state.chatForm,
					...{attachment: '', attachment_mimetype: ''}
				}
			});
		}
	};

	scrollToBottom = () => {
		if (this.messagesEnd) {
			this.messagesEnd.scrollIntoView({ behavior: 'smooth' });
		}
	}

	render() {
		const {translate, show} = this.props;
		const {isLoading, isFormSubmitting, errors, chats, chatForm} = this.state;

		const content = (
			<div className="row">
				<div className="col-sm-12">
					<div className="box box-primary direct-chat direct-chat-primary">
						<div className="box-body">
							<div className="direct-chat-messages" style={{minHeight: '460px'}}>
								{
									chats.map((item, index) => (
										<div className={item.role === 'assistant' ? 'direct-chat-msg' : 'direct-chat-msg right'} key={`chats_${index}`}>
											<div className="direct-chat-info clearfix">
												<span className={item.role === 'assistant' ? 'direct-chat-timestamp pull-left' : 'direct-chat-timestamp pull-right'}>
													{item.role === 'assistant' ? 'PTI Bot' : 'User'}
												</span>
												{/*<span className={item.role === 'assistant' ? 'direct-chat-timestamp pull-right' : 'direct-chat-timestamp pull-left'}>*/}
												{/*	23 Jan 2:00 pm*/}
												{/*</span>*/}
											</div>
											<div className="direct-chat-img">
												<i className="fa fa-2x fa-user-circle img-circle profile-user-img"/>
											</div>
											<div className="direct-chat-text">
												{item.content}
												{(item.attachment && item.attachment !== '') && (
													<div className="img-container">
														<img className="img-rounded img-bordered-sm" src={item.attachment} alt=""/>
													</div>
												)}
											</div>
										</div>
									))
								}
								<div ref={ref => this.messagesEnd = ref}></div>
							</div>
						</div>

						<div className="box-footer">
							{/*<form onSubmit={this.formSubmit}>*/}
								<div className="row">
									<div className="col-sm-8">
										<div className="input-group">
											<Input type="text" placeholder="Type Message ..." value={chatForm.message} onChange={e => this.updateState({message: e.target.value})}/>
											<span className="input-group-btn">
												{isFormSubmitting && <button type="button" className="btn btn-primary btn-flat"><i className="fa fa-refresh fa-spin"/></button>}
												{!isFormSubmitting && (
													<Fragment>
														<button type="button" className="btn btn-primary btn-flat" onClick={this.formSubmit}>Send</button>
														<button type="button" className="btn btn-warning btn-flat" onClick={this.formSubmitImageGenerate}>Generate</button>
													</Fragment>
												)}
											</span>
										</div>
									</div>
									<div className="col-sm-4">
										<input type="file" className="form-control" onChange={this.imageUpload} />
									</div>
								</div>
								{errors.message && <Error text={translate(errors.message[0])}/>}
							{/*</form>*/}
						</div>
					</div>

				</div>
			</div>
		);

		return (
			<Modal show={show} onHide={this._closeModal} className="big-modal">
				<Modal.Header closeButton>
					<Modal.Title id='ChatModalHeader'>{translate('chat_modal_title')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
				{
					!isLoading ? content : <SectionLoader/>
				}
				</Modal.Body>
			</Modal>
		)
	}
}

ChatModal.propTypes = {
	show: PropTypes.bool.isRequired,
	closeAction: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
	translate: getTranslate(state.locale)
});

const mapDispatchToProps = dispatch => bindActionCreators({
	loadLanguage,
	notifySuccess,
	notifyError
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ChatModal);
